import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaBed } from "react-icons/fa";

const Room = ({ building }) => {
  const [rooms, setRooms] = useState([]);

  const isRoomFullFilled = (noOfBedsOccupied, noOfBeds) => {
    return noOfBedsOccupied === noOfBeds;
  };

  const isRoomHalfFilled = (noOfBedsOccupied, noOfBeds) => {
    return noOfBedsOccupied === noOfBeds / 2;
  };
  const getRoomsByBuilding = () => {
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/rooms/get_rooms_by_buildingId/${building?._id}`,
    };
    axios
      .request(config)
      .then((response) => {
        console.log("Response of getRoomsByBuilding: ", response.data);
        setRooms(response.data.data);
      })
      .catch((error) => {
        console.log("Error in getRoomsByBuilding: ", error);
      });
  };

  useEffect(() => {
    if (building) {
      getRoomsByBuilding();
    }
  }, [building]);
  return (
    <div className="sm:px-16 px-6">
      <h2 className="text-2xl font-semibold mb-6">Room Availability</h2>

      <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-5 gap-4 lg:w-1/2">
        {rooms?.map((room, index) => {
          const noOfBedsOccupied =
            room?.beds?.length > 0
              ? room?.beds?.filter((bed) => bed.isOccupied).length
              : 0;
          const noOfBeds = room?.noOfBeds;
          const fulFilled = isRoomFullFilled(noOfBedsOccupied, noOfBeds);
          const halfFilled = isRoomHalfFilled(noOfBedsOccupied, noOfBeds);
          return (
            <div
              className={`flex flex-col gap-1 font-medium tracking-wide p-2 items-center justify-center  rounded border ${
                fulFilled
                  ? "bg-red-300 border-red-600"
                  : halfFilled
                  ? "bg-orange-300 border-orange-600"
                  : "bg-green-300 border-green-600"
              }`}
            >
              <FaBed />
              <span className="text-sm">
                R-F{room?.floorNumber}
                {String(room?.roomNumber).padStart(3, 0)}
              </span>
            </div>
          );
        })}
      </div>

      <div className="my-4 flex gap-4 text-xs font-medium">
        <div className="flex  items-center gap-1">
          <span className="h-3 w-3 bg-green-300"></span>
          <span>Free</span>
        </div>

        <div className="flex items-center gap-1">
          <span className="h-3 w-3 bg-orange-300"></span>
          <span>Half Filled</span>
        </div>

        <div className="flex  items-center gap-1">
          <span className="h-3 w-3 bg-red-300"></span>
          <span>Full Filled</span>
        </div>
      </div>
    </div>
  );
};

export default Room;
